export default __webpack_public_path__ + "static/media/identifiers_card.fc1df4b6.jpg";